import { IconProps } from './index';

const ArrowUpSLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M10 9.023l-4.125 4.125-1.179-1.178L10 6.667l5.303 5.303-1.178 1.178L10 9.023z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ArrowUpSLine;
